import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\CompanyShareholdingController::store
* @see app/Http/Controllers/Investors/CompanyShareholdingController.php:25
* @route '//app.finesthub.de/companies/{company}/shareholdings'
*/
export const store = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/companies/{company}/shareholdings',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Investors\CompanyShareholdingController::store
* @see app/Http/Controllers/Investors/CompanyShareholdingController.php:25
* @route '//app.finesthub.de/companies/{company}/shareholdings'
*/
store.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return store.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\CompanyShareholdingController::store
* @see app/Http/Controllers/Investors/CompanyShareholdingController.php:25
* @route '//app.finesthub.de/companies/{company}/shareholdings'
*/
store.post = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Investors\CompanyShareholdingController::update
* @see app/Http/Controllers/Investors/CompanyShareholdingController.php:63
* @route '//app.finesthub.de/companies/{company}/shareholdings/{shareholder}'
*/
export const update = (args: { company: string | number | { id: string | number }, shareholder: string | number } | [company: string | number | { id: string | number }, shareholder: string | number ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '//app.finesthub.de/companies/{company}/shareholdings/{shareholder}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Investors\CompanyShareholdingController::update
* @see app/Http/Controllers/Investors/CompanyShareholdingController.php:63
* @route '//app.finesthub.de/companies/{company}/shareholdings/{shareholder}'
*/
update.url = (args: { company: string | number | { id: string | number }, shareholder: string | number } | [company: string | number | { id: string | number }, shareholder: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            shareholder: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        shareholder: args.shareholder,
    }

    return update.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{shareholder}', parsedArgs.shareholder.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\CompanyShareholdingController::update
* @see app/Http/Controllers/Investors/CompanyShareholdingController.php:63
* @route '//app.finesthub.de/companies/{company}/shareholdings/{shareholder}'
*/
update.put = (args: { company: string | number | { id: string | number }, shareholder: string | number } | [company: string | number | { id: string | number }, shareholder: string | number ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Investors\CompanyShareholdingController::destroy
* @see app/Http/Controllers/Investors/CompanyShareholdingController.php:80
* @route '//app.finesthub.de/companies/{company}/shareholdings/{shareholder}'
*/
export const destroy = (args: { company: string | number | { id: string | number }, shareholder: string | number } | [company: string | number | { id: string | number }, shareholder: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//app.finesthub.de/companies/{company}/shareholdings/{shareholder}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Investors\CompanyShareholdingController::destroy
* @see app/Http/Controllers/Investors/CompanyShareholdingController.php:80
* @route '//app.finesthub.de/companies/{company}/shareholdings/{shareholder}'
*/
destroy.url = (args: { company: string | number | { id: string | number }, shareholder: string | number } | [company: string | number | { id: string | number }, shareholder: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            shareholder: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        shareholder: args.shareholder,
    }

    return destroy.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{shareholder}', parsedArgs.shareholder.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\CompanyShareholdingController::destroy
* @see app/Http/Controllers/Investors/CompanyShareholdingController.php:80
* @route '//app.finesthub.de/companies/{company}/shareholdings/{shareholder}'
*/
destroy.delete = (args: { company: string | number | { id: string | number }, shareholder: string | number } | [company: string | number | { id: string | number }, shareholder: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const CompanyShareholdingController = { store, update, destroy }

export default CompanyShareholdingController